"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("br", null, null, -1);
exports.default = (0, vue_1.defineComponent)({
    __name: 'ModalBooking',
    props: {
        from: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                class: "modal-reservation",
                style: (0, vue_2.normalizeStyle)(`color:${props.color}; border-color:${props.color};`)
            }, [
                (0, vue_2.createElementVNode)("span", null, [
                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(__props.from) + " ", 1),
                    _hoisted_1,
                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.$trans("reservation", "reservation", "reservation_modal")), 1)
                ])
            ], 4));
        };
    }
});
